/*
 * Enova · Barra de herramientas de colección / búsqueda
 *
 * Complementa el JS del tema (collection-filters-form, collapsible-elements, popout-select),
 * que sigue haciendo el filtrado AJAX y re-renderiza el innerHTML de [data-collection-sidebar].
 * Este archivo solo:
 *  - Escritorio: cierra los paneles de filtros al hacer clic fuera / con Escape, y deja un solo
 *    panel abierto a la vez.
 *  - Tras cada re-render del tema: reabre el grupo que estaba abierto, actualiza el total de
 *    productos de la barra y la fila de filtros activos (chips) que vive fuera del cajón.
 *  - Chips fuera del cajón: delega el clic en el enlace equivalente del cajón (con el listener
 *    del tema) para que el filtrado siga siendo AJAX.
 * Es idempotente: se puede cargar varias veces (dos secciones, editor de temas).
 */
(function () {
  'use strict';

  if (window.EnovaCollectionToolbar) {
    window.EnovaCollectionToolbar.initAll(document);
    return;
  }

  var SEL = {
    toolbar: '[data-enova-toolbar]',
    sidebar: '[data-collection-sidebar]',
    group: '[data-enova-group]',
    collapsible: '[data-collapsible]',
    trigger: '[data-collapsible-trigger]',
    body: '[data-collapsible-body]',
    chipsOut: '[data-enova-chips]',
    chip: '[data-enova-chip]',
    chipsIn: '.collection__active__filters',
    count: '[data-enova-count]',
    countSource: '[data-enova-count-label]',
  };

  var desktopQuery = window.matchMedia('(min-width: 750px)');
  var observers = new WeakMap();

  function isDesktop() {
    return desktopQuery.matches;
  }

  function isOpen(details) {
    return !!details && details.hasAttribute('open') && details.getAttribute('open') !== 'false';
  }

  function groupDetails(group) {
    return group.querySelector(SEL.collapsible);
  }

  function openGroups(root) {
    return Array.prototype.filter.call(root.querySelectorAll(SEL.group), function (group) {
      return isOpen(groupDetails(group));
    });
  }

  function closeGroup(group) {
    var details = groupDetails(group);
    if (!isOpen(details)) return;

    var collapsibles = group.closest('collapsible-elements');
    if (collapsibles && typeof collapsibles.close === 'function') {
      collapsibles.close(details);
    } else {
      details.removeAttribute('open');
    }
  }

  function closeOtherGroups(toolbar, keep) {
    openGroups(toolbar).forEach(function (group) {
      if (group !== keep) closeGroup(group);
    });
  }

  /* Al abrir un panel en escritorio: si se sale por la derecha, alinearlo al borde derecho de la celda. */
  function refreshGroup(group) {
    requestAnimationFrame(function () {
      group.classList.remove('enova-flip');
      if (!isDesktop()) return;
      var panel = group.querySelector(SEL.body);
      if (!panel) return;
      var rect = panel.getBoundingClientRect();
      if (rect.width && rect.right > document.documentElement.clientWidth - 8) {
        group.classList.add('enova-flip');
      }
    });
  }

  function syncCount(toolbar) {
    var source = toolbar.querySelector(SEL.sidebar + ' ' + SEL.countSource);
    if (!source) return;
    var label = source.getAttribute('data-enova-count-label');
    toolbar.querySelectorAll(SEL.count).forEach(function (el) {
      if (el.textContent !== label) el.textContent = label;
    });
  }

  function syncChips(toolbar) {
    var out = toolbar.querySelector(SEL.chipsOut);
    var sidebar = toolbar.querySelector(SEL.sidebar);
    if (!out || !sidebar) return;

    var source = sidebar.querySelector(SEL.chipsIn);
    var fragment = document.createDocumentFragment();
    var clear = null;

    if (source) {
      source.querySelectorAll('a[href]').forEach(function (link) {
        var copy = link.cloneNode(true);
        copy.removeAttribute('data-filter-update-url');
        copy.setAttribute('data-enova-chip', '');
        if (copy.classList.contains('active__filters__clear')) {
          clear = copy;
        } else {
          fragment.appendChild(copy);
        }
      });
    }
    if (clear) fragment.appendChild(clear);

    out.textContent = '';
    out.appendChild(fragment);
    out.hidden = !out.children.length;
  }

  function onSidebarRender(toolbar, sidebar, records) {
    var wasOpen = {};

    records.forEach(function (record) {
      Array.prototype.forEach.call(record.removedNodes, function (node) {
        if (node.nodeType !== 1) return;
        node.querySelectorAll(SEL.group).forEach(function (group) {
          if (isOpen(groupDetails(group))) wasOpen[group.getAttribute('data-enova-group')] = true;
        });
      });
    });

    sidebar.querySelectorAll(SEL.group).forEach(function (group) {
      if (!wasOpen[group.getAttribute('data-enova-group')]) return;
      var details = groupDetails(group);
      var body = group.querySelector(SEL.body);
      if (!details) return;
      details.setAttribute('open', 'true');
      if (body) body.style.height = 'auto';
      refreshGroup(group);
    });

    syncCount(toolbar);
    syncChips(toolbar);
  }

  function init(toolbar) {
    if (!toolbar || toolbar.hasAttribute('data-enova-toolbar-ready')) return;
    toolbar.setAttribute('data-enova-toolbar-ready', '');

    var sidebar = toolbar.querySelector(SEL.sidebar);
    if (sidebar && 'MutationObserver' in window && !observers.has(sidebar)) {
      var observer = new MutationObserver(function (records) {
        onSidebarRender(toolbar, sidebar, records);
      });
      observer.observe(sidebar, { childList: true });
      observers.set(sidebar, observer);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll(SEL.toolbar).forEach(init);
  }

  /* Delegación global (una sola vez) */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    // Chips fuera del cajón → enlace equivalente del cajón (listener AJAX del tema)
    var chip = target.closest(SEL.chip);
    if (chip) {
      var chipToolbar = chip.closest(SEL.toolbar);
      var href = chip.getAttribute('href');
      var match = null;
      if (chipToolbar) {
        chipToolbar.querySelectorAll(SEL.sidebar + ' [data-filter-update-url]').forEach(function (link) {
          if (!match && link.getAttribute('href') === href) match = link;
        });
      }
      if (match) {
        event.preventDefault();
        match.click();
      }
      return;
    }

    // Al abrir un grupo, re-medir su contenido (slider de precio, borde derecho)
    var trigger = target.closest(SEL.trigger);
    var triggerGroup = trigger ? trigger.closest(SEL.group) : null;
    if (triggerGroup && triggerGroup.closest(SEL.toolbar)) refreshGroup(triggerGroup);

    if (!isDesktop()) return;

    var clickedGroup = target.closest(SEL.group);
    document.querySelectorAll(SEL.toolbar).forEach(function (toolbar) {
      closeOtherGroups(toolbar, clickedGroup && toolbar.contains(clickedGroup) ? clickedGroup : null);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !isDesktop()) return;
    document.querySelectorAll(SEL.toolbar).forEach(function (toolbar) {
      var open = openGroups(toolbar);
      if (!open.length) return;
      var focusInside = toolbar.contains(document.activeElement);
      open.forEach(closeGroup);
      if (focusInside) {
        var summary = open[0].querySelector(SEL.trigger);
        if (summary) summary.focus();
      }
    });
  });

  // Al pasar de móvil a escritorio con paneles abiertos (acordeón del cajón), cerrarlos.
  var onBreakpointChange = function () {
    if (!isDesktop()) return;
    document.querySelectorAll(SEL.toolbar).forEach(function (toolbar) {
      openGroups(toolbar).forEach(closeGroup);
    });
  };
  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', onBreakpointChange);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(onBreakpointChange);
  }

  /*
   * Desplazamiento de la barra fija en escritorio: la cabecera fija es todo [data-header-wrapper]
   * (barra de anuncio + header), más alto que --header-height, que solo mide el <header>.
   */
  var headerObserver = null;
  function stickyHeaderParts() {
    var wrapper = document.querySelector('[data-header-wrapper][data-header-sticky]');
    return { wrapper: wrapper, header: wrapper ? wrapper.querySelector('[data-header-height]') : null };
  }
  function updateStickyOffset() {
    var parts = stickyHeaderParts();
    var height = 0;
    if (parts.wrapper) {
      // .theme__header es position:absolute dentro del wrapper: medir hasta su borde inferior.
      var box = parts.wrapper.getBoundingClientRect();
      var bottom = box.bottom;
      if (parts.header) bottom = Math.max(bottom, parts.header.getBoundingClientRect().bottom);
      height = Math.max(0, Math.round(bottom - box.top));
    }
    document.documentElement.style.setProperty('--enova-toolbar-top', height + 'px');
  }
  function watchHeader() {
    updateStickyOffset();
    var parts = stickyHeaderParts();
    if (headerObserver) headerObserver.disconnect();
    if (parts.wrapper && 'ResizeObserver' in window) {
      headerObserver = new ResizeObserver(updateStickyOffset);
      headerObserver.observe(parts.wrapper);
      if (parts.header) headerObserver.observe(parts.header);
    }
  }
  window.addEventListener('resize', updateStickyOffset, { passive: true });
  window.addEventListener('load', updateStickyOffset);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    watchHeader();
  });

  /*
   * <enova-price-range> · rango de precio con dos manijas (snippets/filters.liquid)
   *
   * - Dos <input type="range"> superpuestos (teclado, lector de pantalla y táctil nativos) con
   *   paso data-step (5). Las manijas no se cruzan: siempre queda al menos un paso entre ellas.
   * - Clic en la pista: mueve la manija más cercana a ese punto.
   * - Campos Mínimo / Máximo: se redondean al paso al confirmar (blur / Enter).
   * - Atajos de rango calculados a partir del precio máximo de la colección.
   * - Los <input type="number"> llevan los parámetros filter.v.price.gte / lte; al soltar se llama
   *   a submitForm() del tema (AJAX). Los eventos "input" propios no llegan al listener del tema,
   *   que si no enviaría el formulario a mitad del arrastre.
   */
  var priceFocus = null; // manija con foco de teclado antes del re-render del tema

  class PriceRange extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var self = this;
      this.step = parseFloat(this.getAttribute('data-step')) || 5;
      this.max = parseFloat(this.getAttribute('data-se-max')) || this.step;
      this.currency = this.getAttribute('data-currency') || '';
      this.from = this.snap(parseFloat(this.getAttribute('data-se-min-value')) || 0, 'min');
      this.to = this.snap(parseFloat(this.getAttribute('data-se-max-value')) || this.max, 'max');
      this.timer = null;
      this.usingPointer = false;

      this.slider = this.querySelector('[data-price-slider]');
      this.thumbs = { min: this.querySelector('[data-price-thumb="min"]'), max: this.querySelector('[data-price-thumb="max"]') };
      this.inputs = { min: this.querySelector('[data-price-input="min"]'), max: this.querySelector('[data-price-input="max"]') };
      this.bubbles = { min: this.querySelector('[data-price-bubble="min"]'), max: this.querySelector('[data-price-bubble="max"]') };
      this.summary = this.querySelector('[data-price-summary]');
      this.presets = this.querySelector('[data-price-presets]');

      // Los eventos reales no deben llegar al listener "input" del tema (envío con debounce).
      var swallow = function (event) {
        if (event.isTrusted) event.stopPropagation();
      };
      this.addEventListener('input', swallow);
      this.addEventListener('change', swallow);

      ['min', 'max'].forEach(function (key) {
        var thumb = self.thumbs[key];
        var input = self.inputs[key];

        thumb.addEventListener('pointerdown', function () {
          self.usingPointer = true;
          self.setActive(key);
        });
        thumb.addEventListener('input', function () {
          self.clearTimer();
          self.setValue(key, parseFloat(thumb.value));
          self.setActive(key);
        });
        thumb.addEventListener('change', function () {
          self.schedule(self.usingPointer ? 120 : 650);
        });
        thumb.addEventListener('keydown', function () {
          self.usingPointer = false;
          self.classList.add('is-focus-' + key);
        });
        // Burbuja con foco solo si se llegó con teclado (con el mouse se oculta al soltar).
        thumb.addEventListener('focus', function () {
          var keyboard = false;
          try {
            keyboard = thumb.matches(':focus-visible');
          } catch (error) {
            keyboard = !self.usingPointer;
          }
          self.classList.toggle('is-focus-' + key, keyboard);
        });
        thumb.addEventListener('blur', function () {
          self.classList.remove('is-focus-' + key);
        });

        input.addEventListener('input', function () {
          self.clearTimer();
        });
        input.addEventListener('change', function () {
          self.commitField(key);
        });
        input.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          self.commitField(key);
        });
        input.addEventListener('focus', function () {
          input.select();
        });
      });

      this.onPointerUp = function () {
        self.setActive(null);
      };
      document.addEventListener('pointerup', this.onPointerUp);
      document.addEventListener('pointercancel', this.onPointerUp);

      // Clic en la pista (fuera de las manijas): mover la más cercana a ese punto.
      this.slider.addEventListener('pointerdown', function (event) {
        if (event.target === self.thumbs.min || event.target === self.thumbs.max) return;
        var rect = self.slider.getBoundingClientRect();
        if (!rect.width) return;
        var ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
        var value = Math.round((ratio * self.max) / self.step) * self.step;
        var key = Math.abs(value - self.from) <= Math.abs(value - self.to) ? 'min' : 'max';
        if (value === self.from && value === self.to) key = value >= self.max ? 'min' : 'max';
        self.usingPointer = true;
        self.setValue(key, value);
        self.setActive(key);
        self.thumbs[key].focus({ preventScroll: true });
        self.schedule(120);
      });

      this.buildPresets();
      this.render();

      if (priceFocus && this.thumbs[priceFocus] && this.offsetParent) {
        var restore = this.thumbs[priceFocus];
        priceFocus = null;
        requestAnimationFrame(function () {
          restore.focus({ preventScroll: true });
        });
      }
    }

    disconnectedCallback() {
      this.clearTimer();
      if (this.onPointerUp) {
        document.removeEventListener('pointerup', this.onPointerUp);
        document.removeEventListener('pointercancel', this.onPointerUp);
      }
    }

    snap(value, key) {
      if (isNaN(value)) value = key === 'min' ? 0 : this.max;
      var rounded = key === 'min' ? Math.floor(value / this.step) * this.step : Math.ceil(value / this.step) * this.step;
      return Math.min(this.max, Math.max(0, rounded));
    }

    gap() {
      return this.max >= this.step ? this.step : 0;
    }

    setValue(key, value) {
      if (key === 'min') {
        this.from = Math.max(0, Math.min(value, this.to - this.gap()));
      } else {
        this.to = Math.min(this.max, Math.max(value, this.from + this.gap()));
      }
      this.render();
    }

    setActive(key) {
      this.classList.toggle('is-active-min', key === 'min');
      this.classList.toggle('is-active-max', key === 'max');
    }

    format(value) {
      var number = Number(value).toLocaleString('es-PE', { maximumFractionDigits: 0 });
      return this.currency ? this.currency + ' ' + number : number;
    }

    render() {
      var from = this.from;
      var to = this.to;

      this.style.setProperty('--from', from / this.max);
      this.style.setProperty('--to', to / this.max);
      this.setAttribute('data-se-min-value', from);
      this.setAttribute('data-se-max-value', to);

      if (String(this.thumbs.min.value) !== String(from)) this.thumbs.min.value = from;
      if (String(this.thumbs.max.value) !== String(to)) this.thumbs.max.value = to;
      this.thumbs.min.setAttribute('aria-valuetext', this.format(from));
      this.thumbs.max.setAttribute('aria-valuetext', this.format(to));
      if (document.activeElement !== this.inputs.min) this.inputs.min.value = from;
      if (document.activeElement !== this.inputs.max) this.inputs.max.value = to;

      this.bubbles.min.textContent = this.format(from);
      this.bubbles.max.textContent = this.format(to);
      this.summary.textContent = this.format(from) + ' – ' + this.format(to);

      // Con las dos manijas al final, la mínima queda encima para poder arrastrarla.
      this.classList.toggle('is-min-on-top', from >= this.max - this.step);
      this.classList.toggle('is-default', from === 0 && to === this.max);

      if (this.presets) {
        this.presets.querySelectorAll('[data-from]').forEach(function (button) {
          var active = parseFloat(button.getAttribute('data-from')) === from && parseFloat(button.getAttribute('data-to')) === to;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
    }

    /* Atajos: cuartos del precio máximo, redondeados a cifras "limpias" (10 / 50 / 100). */
    buildPresets() {
      if (!this.presets || this.max < this.step * 4) return;
      var self = this;
      var unit = this.max >= 1000 ? 100 : this.max >= 300 ? 50 : this.max >= 40 ? 10 : this.step;
      var cuts = [0.25, 0.5, 0.75]
        .map(function (part) {
          // Empates (x.5) hacia abajo para que los cortes queden equidistantes (10 / 20 / 30).
          return Math.round((self.max * part) / unit - 0.001) * unit;
        })
        .filter(function (cut, index, list) {
          return cut > 0 && cut < self.max && list.indexOf(cut) === index;
        });
      if (cuts.length < 2) return;

      var points = [0].concat(cuts, [this.max]);
      var fragment = document.createDocumentFragment();
      for (var i = 0; i < points.length - 1; i++) {
        var from = points[i];
        var to = points[i + 1];
        var label;
        if (i === 0) label = 'Hasta ' + this.format(to);
        else if (i === points.length - 2) label = 'Más de ' + this.format(from);
        else label = this.format(from) + ' – ' + this.format(to);

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'enova-price__preset';
        button.setAttribute('data-from', from);
        button.setAttribute('data-to', to);
        button.textContent = label;
        fragment.appendChild(button);
      }
      this.presets.appendChild(fragment);
      this.presets.hidden = false;

      this.presets.addEventListener('click', function (event) {
        var button = event.target.closest('[data-from]');
        if (!button) return;
        var active = button.classList.contains('is-active');
        self.from = active ? 0 : parseFloat(button.getAttribute('data-from'));
        self.to = active ? self.max : parseFloat(button.getAttribute('data-to'));
        self.render();
        self.submit();
      });
    }

    commitField(key) {
      var input = this.inputs[key];
      var raw = parseFloat(String(input.value).replace(',', '.'));
      var before = key === 'min' ? this.from : this.to;
      var value = this.snap(raw, key);

      if (key === 'min' && value > this.to - this.gap()) {
        // Mínimo por encima del máximo: mover el máximo con él.
        this.to = Math.min(this.max, value + this.gap());
        value = Math.min(value, this.to - this.gap());
      }
      if (key === 'max' && value < this.from + this.gap()) {
        this.from = Math.max(0, value - this.gap());
        value = Math.max(value, this.from + this.gap());
      }

      if (key === 'min') this.from = value;
      else this.to = value;
      input.value = value;
      this.render();
      if (value !== before || isNaN(raw)) this.schedule(0);
    }

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

    schedule(delay) {
      var self = this;
      this.clearTimer();
      this.timer = setTimeout(function () {
        self.timer = null;
        self.submit();
      }, delay);
    }

    submit() {
      this.clearTimer();
      this.inputs.min.value = this.from;
      this.inputs.max.value = this.to;

      var start = parseFloat(this.getAttribute('data-applied-from'));
      var end = parseFloat(this.getAttribute('data-applied-to'));
      if (start === this.from && end === this.to) return;
      this.setAttribute('data-applied-from', this.from);
      this.setAttribute('data-applied-to', this.to);

      var active = document.activeElement;
      priceFocus = !this.usingPointer && active === this.thumbs.min ? 'min' : !this.usingPointer && active === this.thumbs.max ? 'max' : null;
      // El tema re-renderiza el cajón (y este elemento) al terminar; por si no llega, quitar el estado.
      var self = this;
      this.classList.add('is-loading');
      setTimeout(function () {
        self.classList.remove('is-loading');
      }, 4000);

      var filtersForm = this.closest('collection-filters-form');
      if (filtersForm && typeof filtersForm.submitForm === 'function') {
        filtersForm.submitForm(new Event('change'));
      } else {
        // Respaldo: el listener "input" del tema (con debounce) envía el formulario.
        this.inputs.max.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }

  if (window.customElements && !window.customElements.get('enova-price-range')) {
    window.customElements.define('enova-price-range', PriceRange);
  }

  window.EnovaCollectionToolbar = { init: init, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      watchHeader();
    });
  } else {
    initAll(document);
    watchHeader();
  }
})();
